/* eslint-disable no-param-reassign */
// import { createChart } from './PDFDotPlotBullet';
import defaultChart from './PDFBaseChart';

export default (metric, options) => {
    const { colour, label, definition } = options;
    const metricChart = metric.chartType === 'deprivation_type';
    // definition.h = 'h-1-5/8';
    const deprivationChart = {
        // y: metricChart ? (metric.y || 0) : 'h-0-1/4',
        label,
        definition,
        chartHeader: {
            font: { size: 'sm' },
            // h: 'h-0-3/8',
            mb: 'h-0-1/16',
            mt: 'h-0-1/16',
            label: {
                text: 'Most Well Off'
            },
            valueLabel: {
                position: 'parent',
                text: metric.valueLabel,
                w: 'w-3-1/2',
                align: 'right',
                font: !metricChart && { colour }
            },
            comparisonLabel: {
                position: 'parent',
                text: metric.comparisonLabel,
                w: 'w-4',
                align: 'right',
                font: metricChart && { weight: 'bold' }
            }
        }
    };
    for (let i = 0; i < metric.submodels.length; i++) {
        const subMetric = metric.submodels[i];
        // const { chart, colour } = defaultChart(subMetric, template);
        const subChart = defaultChart(subMetric,
            {
                font: { size: 'sm' },
                h: metricChart ? 'h-0-5/16' : 'h-0-1/2',
                // border: { colour: '#00ff00' },
                label: {
                    // border: { colour: '#000000' },
                    text: subMetric.label,
                    w: 'w-0-1/4'
                },
                chart: {
                    display: 'inline',
                    // border: { colour: '#ff0000' },
                    mt: -1,
                    // preserveAspectRatio: metricChart,
                    // y: metricChart && 1,
                    h: !metricChart && 'h-0-7/16',
                    w: metricChart ? 'w-2-3/4' : 'w-3'
                },
                // mt: 2,
                colour
            });
        subChart.value = {
            position: 'parent',
            text: `${subMetric.format(subMetric.value)}${subMetric.valueUnits}`,
            w: 'w-3-1/2',
            font: !metricChart && { colour },
            align: 'right'
        };
        subChart.comparison = {
            position: 'parent',
            text: `${subMetric.format(subMetric.comparisonValue)}${subMetric.valueUnits}`,
            w: 'w-4',
            font: metricChart && { weight: 'bold' },
            align: 'right'
        };
        deprivationChart[subMetric.id] = subChart;
    }
    deprivationChart.footerLabel = {
        font: { size: 'sm' },
        text: 'Most Deprived'
    };
    // deprivationChart.h = metricChart ? 'h-4-1/2' : 'h-5';
    return deprivationChart;
};
